export default () => '99/99/9999'
